import { StakeToSpinResponseData } from "@lib/titan2-slingo/dist/api/data/StakeToSpinResponseData";
import { ExtendedGameUpdateData } from "../../data/ExtendedGameUpdateData";
import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { ApiConstants } from "../../enum/Constants";
import { unpackChanceGameData } from "./unpackChanceGameData";
/**
 * ExtendedStakeToSpinResponseData.ts
 */
export class ExtendedStakeToSpinResponseData extends StakeToSpinResponseData {
    solidify() {
        super.solidify();
        if (this.isSuccess() && this.dataExists(this.data)) {
            this.solidifyChanceGame();
        }
    }
    solidifyGameUpdate() {
        if (this.dataExists(this.data)) {
            this.gameUpdate = new ExtendedGameUpdateData(this.data);
        }
    }
    solidifyChanceGame() {
        this.chanceGame = null;
        const spinResult = this.data.getDataObject(SlingoConstants.PROPERTY_SPIN_RESULT);
        const feature = spinResult.getDataObject(ApiConstants.PROPERTY_FEATURE);
        if (feature) {
            const chanceGame = feature.getDataObject(ApiConstants.PROPERTY_CHANCE_GAME);
            this.chanceGame = unpackChanceGameData(chanceGame);
        }
    }
    getChanceGames() {
        return this.chanceGame ? [this.chanceGame] : null;
    }
    getChanceGame() {
        return this.chanceGame ?? null;
    }
}
//# sourceMappingURL=ExtendedStakeToSpinResponseData.js.map